import React from 'react';
import { PropTypes } from 'prop-types';

import { selectCurrentData } from '../App/selectors';

import { connect }  from 'react-redux';

import { withStyles } from '@material-ui/core/styles';

import WebViewFW from '../components/flipwitComponents/WebViewFW';

import { platformHandler } from '../platforms/PlatformHandler'
import { languageManager } from '../utils/languageManager'

import BarChartTwoToneIcon from '@material-ui/icons/BarChartTwoTone';
import WebIcon from '@material-ui/icons/Web';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import AssistantIcon from '@material-ui/icons/Assistant';
import TextFields from '@material-ui/icons/TextFields';
import CircularProgress from '@material-ui/core/CircularProgress';


import { PluginHandler } from '../utils/pluginHandler';

import {FwScene} from './FwScene'


const styles = theme => ({  
	flipwitContent: {
	    height:'100%',
	    display: 'flex',    
	    justifyContent: 'start',
	    alignItems: 'center',
	    flexWrap: 'nowrap',    
	    flexDirection: 'column',     
	    width: '100%',	    
	  },   

	optionsContainer: {
		width: "100%",
    	height: "30%",
    	display: "flex",
	},

	arrowsContainer: {
		width: "10%",
    	height: "100%",
	},

	optionsIntContainer: {
		width: "80%",
    	height: "100%",
    	display: 'flex',
		alignItems: "center",
    	justifyContent: "center",
    	/*overflowX: 'auto',
    	overflowY: 'hidden',*/
	},

	option: {
		height: '80%',
		width: 150,
		//minWidth: 150,
		//backgroundColor: 'white',
		margin: "0px 10px",
		display: "flex",
		alignItems: "center",
    	justifyContent: "center",
    	flexDirection: "column",
    	cursor: 'pointer',
    	backgroundColor: '#E0E0E0',
    	position: 'relative',
	},

	iconQuestion: {
		backgroundColor: "black",
	    color: "white",
	    borderRadius: "5px",
	    width: 30,
		height: 30,
	},

	icons: {
		width: 40,
		height: 40,
	},

	optionText: {
		fontSize: '1em',
    	fontFamily: 'Roboto-Medium',
    	textTransform: 'uppercase', 
    	textAlign: "center",
    	marginTop: 10,
    	userSelect: 'none',
    	zIndex: 1,
	},

	arrowSelected: {
		width: "30px",
	    height: "30px",
	    backgroundColor: "white",
	    transform: "rotate(45deg)",
	    position: "absolute",
	    bottom: "-15px",
	},

	divWebview: {
		height: "70%",
		width: "100%",
		display: "flex",
    	alignItems: "center",
    	justifyContent: "center",
    	position: "relative",
	}
});

class MainMenu extends FwScene {
	state = {
		optionSelected:'INSERT_SURVEY',
		currentUrl:"",
	}

	constructor(props) {
		super(props)

		this.pluginHandler = new PluginHandler();
	  	this.onReceiveMessage = this.onReceiveMessage.bind(this);	  	
	}

	componentDidMount(){
		this.refreshCurrentUrl(this.state.optionSelected);
		platformHandler.checkTitleBarScene("MainMenu");  
	}

	onButtonPress( index ){
	    this.setState({optionSelected: index}) 
		this.refreshCurrentUrl(index);
	};

	refreshCurrentUrl = (index) => {

		let newUrl = "";	
		let suffixUrl = "?" + new Date().getTime();

		//TODO2
		//let urlPlugins = "./plugins";
		//let urlPlugins = "./pluginsTest";
		let urlPlugins = "https://app.flipwit.com/pluginsTest";

		switch(index) {
			case 'INSERT_SURVEY': newUrl= urlPlugins + "/survey/editor/index.html";
									//newUrl="./plugins/survey/editor/index.html";
									//newUrl="http://192.168.1.53:3001?" + this.date; 
									//newUrl="http://192.168.1.53/flipwit_plugins/static/survey/editor/"; 
								break;

			case 'INSERT_URL': 	newUrl= urlPlugins + "/url/editor/index.html";
								//newUrl="http://192.168.1.53/flipwit_plugins/static/url/editor/; 
								break;

			case 'INSERT_YOUTUBE': newUrl= urlPlugins + "/youtube/editor/index.html"; 
								//newUrl="http://192.168.1.53/flipwit_plugins/static/youtube/editor/";
								break;

			case 'INSERT_TUTORIAL': newUrl= urlPlugins + "/connection/editor/index.html";
								//newUrl="http://192.168.1.53/flipwit_plugins/static/connection/editor/";
								break;

			case 'INSERT_WORD_CLOUD': newUrl= urlPlugins + "/wordcloud/editor/index.html";
								//newUrl="http://192.168.1.53/flipwit_plugins/static/connection/editor/";
								//newUrl="http://192.168.1.53:3001";
								break;
			
			default:
		}
		
		newUrl = newUrl+suffixUrl;

		console.log('Cargar ',newUrl)
		this.setState({currentUrl:newUrl,showLoader:true})
	}

	getOption(icon,optionText) {
		const { classes } = this.props;

		let selected = this.state.optionSelected === optionText;
	
		let style = selected?{backgroundColor:'white'}:{};

		return (<div id={'option_'+optionText} className={classes.option} onClick={() => this.onButtonPress(optionText)} style={style}>
				{icon}
				<div className={classes.optionText}>{languageManager.getLangWord(optionText)}</div>
				{selected && <div className={classes.arrowSelected}></div>}
			</div>);
	}

	onReceiveMessage(msg){
		if(msg===undefined) return;
		console.log('recibio mode: ', msg,this.pluginViewer)
		try {
			let jsonMsg = JSON.parse( msg );

		    this.pluginHandler.messageFromWebPlugin( jsonMsg, this.pluginViewer, this.props.currentData );			
		}
		catch(e) {
			console.log('ERROR EN JSON',msg, e)
		}
		
		/*
		let jsonMsg = JSON.parse( msg );
		
		this.pluginHandler.messageFromWebPlugin( jsonMsg, this.webViewer, this.props.currentData, true);*/
	}

	onHandleReady(){
	    this.setState({ showLoader:false }) 
	}

	render() {

		const { classes } = this.props;
		
		console.log('URL: ',this.state.currentUrl)
		//if(platformHandler.getUser()===null) return null;

		return (
			<React.Fragment>					
				<div className={classes.flipwitContent}>
					<div className={classes.optionsContainer}>
						<div className={classes.arrowsContainer}></div>
						<div className={classes.optionsIntContainer}>
							{this.getOption(<BarChartTwoToneIcon className={classes.iconQuestion} />,'INSERT_SURVEY')}
							{this.getOption(<TextFields className={classes.iconQuestion} />,'INSERT_WORD_CLOUD')}
							{this.getOption(<WebIcon className={classes.icons} />,'INSERT_URL')}
							{this.getOption(<VideoLibraryIcon className={classes.icons} />,'INSERT_YOUTUBE')}
							{this.getOption(<AssistantIcon className={classes.icons} />,'INSERT_TUTORIAL')}							
						</div>
						<div className={classes.arrowsContainer}></div>						
					</div>
					{/*<div style={{width:"100%",height:"10%"}}></div>*/}
					<div className={classes.divWebview}>
						{this.state.showLoader && <React.Fragment>
    		        		<CircularProgress size={50} style={{position: "absolute"}} />
    					</React.Fragment>}
						<WebViewFW ref={(child) => { this.pluginViewer = child; }}
							name="pluginViewerMainMenu"
						    //urlWebView={ "http://localhost:3001/?"  + this.date  }
						    urlWebView={ this.state.currentUrl }
						    //urlWebView={ "http://192.168.1.53/flipwit_plugins/static/survey/editor/?" + this.date }
						    //pointerEvents={"none"}
						   	height={"100%"}
						   	style={{padding:10}}
						    //idToglea={ currentData.idToglea }
						    handleReceiveMessage={this.onReceiveMessage.bind(this)}
						    //handleReceiveMessage={this.onReceiveMessage}
				    		handleReady={this.onHandleReady.bind(this)}
						    //onClick={() => {if(platformHandler.isFullScreen()) this.onButtonPress("Next", true)}}
						  />
					</div>
			    </div>
		    </React.Fragment>);
	}
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,  
};

MainMenu.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => {  	
  return {
  	currentData: selectCurrentData(state),  	      
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(MainMenu));




// WEBPACK FOOTER //
// ./src/containers/scenes/MainMenu.js